import React, { useContext, useEffect, useRef, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Paper from "@material-ui/core/Paper";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import Switch from "@material-ui/core/Switch";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import ToggleButton from "@material-ui/lab/ToggleButton";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Badge from "@material-ui/core/Badge";
import MoveToInboxIcon from "@material-ui/icons/MoveToInbox";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import LockIcon from "@material-ui/icons/Lock"; // ✅ AGREGADO: Para icono de tickets cerrados
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import WarningIcon from "@material-ui/icons/Warning"; // ✅ AGREGADO: Para icono de alerta
import Typography from "@material-ui/core/Typography"; // ✅ AGREGADO: Para mejor tipografía
import Box from "@material-ui/core/Box"; // ✅ AGREGADO: Para layout mejorado
import Radio from "@material-ui/core/Radio"; // ✅ AGREGADO: Para selección de opciones
import RadioGroup from "@material-ui/core/RadioGroup"; // ✅ AGREGADO: Para grupo de opciones
import FormControlLabel from "@material-ui/core/FormControlLabel"; // ✅ AGREGADO: Para labels de opciones
import FormControl from "@material-ui/core/FormControl"; // ✅ AGREGADO: Para control de formulario
import api from "../../services/api"; // ✅ AGREGADO: Para llamadas a la API

import {
  Add as AddIcon,
} from "@material-ui/icons";

import NewTicketModal from "../NewTicketModal";
import TicketsListCustom from "../TicketsListCustom";
import TabPanel from "../TabPanel";
import TransferTicketModalCustom from "../TransferTicketModalCustom";
import ConfirmationModal from "../ConfirmationModal"; // ✅ AGREGADO: Para confirmación de cerrar tickets
import SearchResultsPanel from "../SearchResultsPanel"; // ✅ AGREGADO: Para búsqueda global
// ✅ ELIMINADO: DuplicateTicketsCorrectionModal - Ya no se usa

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { canSeeTeamTickets } from "../../helpers/userAccess";
import { SocketContext } from "../../context/Socket/SocketContext";

import FilterPanel from "../FilterPanel";
import FilterListIcon from "@material-ui/icons/FilterList";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import BusinessIcon from "@material-ui/icons/Business";
import Chip from "@material-ui/core/Chip";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import Fab from "@material-ui/core/Fab";
import Button from "@material-ui/core/Button";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ForumIcon from "@material-ui/icons/Forum";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import MarkunreadIcon from "@material-ui/icons/Markunread";
import { BORDERS } from "../../theme/redesign";

const useStyles = makeStyles(theme => ({
	ticketsWrapper: {
		position: "relative",
		display: "flex",
		height: "100%",
		flexDirection: "column",
		overflow: "hidden",
		borderRadius: 16,
		border: "none",
		backgroundColor: theme.mode === "dark" ? "#111827" : "#ffffff",
		[theme.breakpoints.down("sm")]: {
			borderRadius: 0,
		},
	},
	ticketsWrapperWhatsapp: {
		boxShadow: theme.mode === "dark"
			? "inset 3px 0 0 #25D366"
			: "inset 3px 0 0 #25D366",
		backgroundColor: theme.mode === "dark" ? "#0f1a14" : "#f4fbf6",
	},
	ticketsWrapperTelegram: {
		boxShadow: theme.mode === "dark"
			? "inset 3px 0 0 #229ED9"
			: "inset 3px 0 0 #229ED9",
		backgroundColor: theme.mode === "dark" ? "#0f1720" : "#f3f9fd",
	},
	channelSwitch: {
		display: "flex",
		alignItems: "center",
		gap: 6,
		padding: "4px 12px 8px",
		overflowX: "auto",
		overflowY: "hidden",
		WebkitOverflowScrolling: "touch",
		...theme.hiddenScrollbar,
		"& > *": {
			flexShrink: 0,
		},
		[theme.breakpoints.down("sm")]: {
			padding: "2px 8px 6px",
			gap: 4,
		},
	},
	channelChip: {
		border: "none",
		cursor: "pointer",
		textTransform: "none",
		fontWeight: 700,
		fontSize: 12,
		borderRadius: 999,
		padding: "5px 12px",
		backgroundColor: theme.mode === "dark" ? "#1f2937" : "#eef1f6",
		color: theme.mode === "dark" ? "#cbd5e1" : "#64748b",
		display: "inline-flex",
		alignItems: "center",
		gap: 6,
		lineHeight: 1.2,
		"&:hover": {
			opacity: 0.92,
		},
	},
	channelChipAllSelected: {
		backgroundColor: theme.palette.primary.main,
		color: "#fff",
	},
	channelChipWhatsappSelected: {
		backgroundColor: "#25D366",
		color: "#fff",
	},
	channelChipTelegramSelected: {
		backgroundColor: "#229ED9",
		color: "#fff",
	},
	channelDot: {
		width: 8,
		height: 8,
		borderRadius: "50%",
		display: "inline-block",
		flexShrink: 0,
	},
	statusTabsWhatsapp: {
		"& .Mui-selected": {
			backgroundColor: "#128C7E !important",
			color: "#fff !important",
		},
	},
	statusTabsTelegram: {
		"& .Mui-selected": {
			backgroundColor: "#229ED9 !important",
			color: "#fff !important",
		},
	},

	ticketsContainer: {
		flex: 1,
		display: "flex",
		flexDirection: "column",
		height: "100%",
		minHeight: 0, // Importante para que flex funcione correctamente
		overflow: "hidden",
	},


	tabsHeader: {
		flex: "none",
		backgroundColor: theme.palette.tabHeaderBackground,
		borderBottom: BORDERS.base(theme),
	},

	tabsInternal: {
		flex: "none",
		backgroundColor: theme.palette.tabHeaderBackground
	},

	settingsIcon: {
		alignSelf: "center",
		marginLeft: "auto",
		padding: 8,
	},
  snackbar: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "#1e3a8a",
    color: "white",
    borderRadius: 30,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8em",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1em",
    },
  },

  yesButton: {
    backgroundColor: "#FFF",
    color: "#10b981",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#10b981",
      color: "#FFF",
    },
    borderRadius: 30,
  },
  noButton: {
    backgroundColor: "#FFF",
    color: "#ef4444",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    "&:hover": {
      backgroundColor: "#ef4444",
      color: "#FFF",
    },
    borderRadius: 30,
  },

  // ✅ CORREGIDO: Estilos para el buscador dinámicos según tema
  searchInputWrapperNew: {
    display: "flex",
    alignItems: "center",
    padding: "8px 12px",
    margin: "10px 12px 6px",
    minWidth: 0,
    borderRadius: 999,
    backgroundColor: theme.mode === "dark" ? "#1f2937" : "#f1f3f9",
    border: "none",
    boxShadow: "none",
    [theme.breakpoints.down("sm")]: {
      margin: "4px 8px 6px",
      padding: "4px 10px",
      minHeight: 36,
    },
  },

  searchIconNew: {
    color: theme.palette.text.secondary || theme.palette.text.primary,
    marginRight: "8px",
    fontSize: "20px",
  },

  searchInputNew: {
    flex: 1,
    fontSize: "14px",
    color: theme.palette.text.primary,
    "& input": {
      padding: "4px 0",
      fontSize: "14px",
      color: theme.palette.text.primary,
    },
    "& input::placeholder": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
      fontSize: "14px",
    },
  },

  searchSwitchNew: {
    marginLeft: "8px",
    "& .MuiSwitch-thumb": {
      width: "16px",
      height: "16px",
    },
    "& .MuiSwitch-track": {
      height: "12px",
      borderRadius: "6px",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  // ✅ CORREGIDO: Estilos para la barra de herramientas dinámicos según tema
  quickActionsBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "8px",
    padding: "4px 12px 10px",
    backgroundColor: "transparent",
    borderBottom: "none",
    minHeight: 40,
    overflowX: "auto",
    overflowY: "hidden",
    WebkitOverflowScrolling: "touch",
    ...theme.hiddenScrollbar,
    [theme.breakpoints.down(1280)]: {
      padding: "8px 10px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "6px 8px",
      minHeight: 48,
      gap: 4,
    },
  },

  quickActionsLeft: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    flex: "0 0 auto",
    height: 36,
  },

  quickActionsRight: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    flex: "0 0 auto",
    marginLeft: "auto",
    height: 36,
  },

  quickActionButton: {
    padding: "4px 10px !important",
    margin: 0,
    minWidth: "auto !important",
    width: "auto",
    height: 32,
    border: "0 !important",
    borderRadius: 999,
    backgroundColor: `${theme.mode === "dark" ? "#1f2937" : "#f1f3f9"} !important`,
    color: theme.palette.text.secondary,
    lineHeight: 1,
    "& svg": {
      fontSize: 18,
    },
    "&:hover": {
      backgroundColor: `${theme.mode === "dark" ? "#334155" : "#e8ebf4"} !important`,
    },
    "&.Mui-selected": {
      backgroundColor: `${theme.palette.primary.main} !important`,
      color: "#fff !important",
      boxShadow: "none !important",
    },
  },
  quickActionIconButton: {
    padding: "6px !important",
    margin: 0,
    minWidth: "32px !important",
    width: 32,
    height: 32,
    border: "0 !important",
    borderRadius: 999,
    backgroundColor: `${theme.mode === "dark" ? "#1f2937" : "#f1f3f9"} !important`,
    color: theme.palette.text.secondary,
    lineHeight: 0,
    "& svg": {
      fontSize: 18,
    },
    "&:hover": {
      backgroundColor: `${theme.mode === "dark" ? "#334155" : "#e8ebf4"} !important`,
    },
  },

	tab: {
		minWidth: 120,
		width: 120,
	},

	internalTab: {
		minWidth: 120,
		width: 120,
		padding: 5
	},

	ticketOptionsBox: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		background: theme.palette.optionsBackground,
		padding: theme.spacing(1),
	},

	ticketSearchLine: {
		padding: theme.spacing(1),
	},

	serachInputWrapper: {
		flex: 1,
		background: theme.palette.total,
		display: "flex",
		borderRadius: 40,
		padding: 4,
		marginRight: theme.spacing(1),
	},

	searchIcon: {
		color: "grey",
		marginLeft: 6,
		marginRight: 6,
		alignSelf: "center",
	},

	searchInput: {
		flex: 1,
		border: "none",
		borderRadius: 30,
	},

	insiderTabPanel: {
		height: '100%',
		marginTop: "-72px",
		paddingTop: "72px"
	},

	insiderDoubleTabPanel: {
		display:"flex",
		flexDirection: "column",
		marginTop: "-72px",
		paddingTop: "72px",
		height: "100%"
	},

	labelContainer: {
		width: "auto",
		padding: 0
	},
	iconLabelWrapper: {
		flexDirection: "row",
		'& > *:first-child': {
			marginBottom: '3px !important',
			marginRight: 16
		}
	},
	insiderTabLabel: {
		[theme.breakpoints.down(1600)]: {
			display:'none'
		}
	},
  statusTabs: {
    minHeight: 36,
    padding: "0 8px 8px",
    "& .MuiTabs-scroller": {
      ...theme.hiddenScrollbar,
    },
    "& .MuiTabs-indicator": {
      display: "none",
    },
    "& .MuiTab-root": {
      minWidth: 0,
      minHeight: 32,
      padding: "4px 12px",
      marginRight: 6,
      borderRadius: 999,
      textTransform: "none",
      fontWeight: 600,
      fontSize: 13,
      backgroundColor: theme.mode === "dark" ? "#1f2937" : "#f1f3f9",
      color: theme.mode === "dark" ? "#cbd5e1" : "#64748b",
      [theme.breakpoints.down("sm")]: {
        padding: "3px 8px",
        fontSize: 12,
        minHeight: 28,
        marginRight: 4,
      },
    },
    "& .Mui-selected": {
      backgroundColor: theme.palette.primary.main,
      color: "#fff !important",
    },
    [theme.breakpoints.down("sm")]: {
      minHeight: 32,
      padding: "0 4px 4px",
      "& .MuiTabs-scrollButtons": {
        width: 22,
      },
    },
  },
  mobileFilterControls: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 6,
    "& > div": {
      padding: 0,
      maxWidth: "100%",
    },
  },
  ticketsTopBar: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "10px 12px 4px",
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      padding: "6px 8px 2px",
      flexWrap: "nowrap",
      gap: 4,
      overflowX: "auto",
      overflowY: "hidden",
      WebkitOverflowScrolling: "touch",
      ...theme.hiddenScrollbar,
      "& > *": {
        flexShrink: 0,
      },
    },
  },
  scopeButton: {
    textTransform: "none",
    fontWeight: 700,
    fontSize: 13,
    borderRadius: 10,
    padding: "6px 12px",
    backgroundColor: theme.mode === "dark" ? "#1f2937" : "#eef0ff",
    color: theme.palette.primary.main,
    [theme.breakpoints.down("sm")]: {
      padding: "4px 8px",
      fontSize: 12,
      minWidth: 0,
      "& .MuiButton-startIcon": {
        marginRight: 4,
      },
      "& .MuiButton-endIcon": {
        marginLeft: 0,
      },
    },
  },
  ghostButton: {
    textTransform: "none",
    fontWeight: 600,
    fontSize: 13,
    borderRadius: 10,
    padding: "6px 12px",
    color: theme.palette.text.secondary,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  unreadButton: {
    textTransform: "none",
    fontWeight: 600,
    fontSize: 13,
    borderRadius: 999,
    padding: "4px 12px",
    marginLeft: "auto",
    color: theme.palette.primary.main,
    backgroundColor: theme.mode === "dark" ? "#1e1b4b" : "#eef0ff",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  unreadButtonOff: {
    textTransform: "none",
    fontWeight: 600,
    fontSize: 13,
    borderRadius: 999,
    padding: "4px 12px",
    marginLeft: "auto",
    color: theme.palette.text.secondary,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  statusCount: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 18,
    height: 18,
    marginLeft: 6,
    padding: "0 5px",
    borderRadius: 999,
    fontSize: 11,
    fontWeight: 700,
    backgroundColor: "#22c55e",
    color: "#fff",
  },
  statusCountMuted: {
    backgroundColor: theme.mode === "dark" ? "#334155" : "#cbd5e1",
    color: theme.mode === "dark" ? "#e2e8f0" : "#334155",
  },
  resolvedChip: {
    height: 22,
    fontSize: 11,
    fontWeight: 700,
    backgroundColor: "#4F46F5",
    color: "#fff",
  },
  fabNewTicket: {
    position: "absolute",
    left: 16,
    bottom: 16,
    zIndex: 6,
    width: 48,
    height: 48,
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    boxShadow: "0 8px 20px rgba(79, 70, 245, 0.35)",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
    [theme.breakpoints.down("sm")]: {
      left: 12,
      bottom: "calc(12px + env(safe-area-inset-bottom, 0px))",
      width: 44,
      height: 44,
    },
  },
	smallFormControl: {
		'& .MuiOutlinedInput-input': {
			padding: "12px 10px",
		},
		'& .MuiInputLabel-outlined': {
			marginTop: "-6px"
		}
	}
}));

const TicketsManagerTabs = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const history = useHistory();
  
  // ✅ FUNCIÓN PARA DETERMINAR LA PESTAÑA CORRECTA SEGÚN EL TIPO DE TICKET (NO UTILIZADA)
  // const getTabForTicket = (ticket) => {
  //   if (ticket.contact && ticket.contact.isGroup) {
  //     // ✅ GRUPOS: Solo van a "GRUPOS" o "CERRADOS"
  //     return ticket.status === "closed" ? "closed" : "groups";
  //   } else {
  //     // ✅ CONTACTOS INDIVIDUALES: Flujo normal
  //     return ticket.status;
  //   }
  // };

  // ✅ FUNCIÓN PARA MANEJAR CAMBIOS DE ESTADO DE TICKETS (NO UTILIZADA)
  // const handleTicketStatusChange = (ticket, newStatus) => {
  //   const currentTab = getTabForTicket(ticket);
  //   const newTab = getTabForTicket({ ...ticket, status: newStatus });
  //   
  //   // ✅ Si el ticket cambia de pestaña, actualizar la vista
  //   if (currentTab !== newTab) {
  //     if (newTab === "groups") {
  //       setTabOpen("groups");
  //     } else if (newTab === "closed") {
  //       setTabOpen("closed");
  //     }
  //   }
  // };
  


  
  const [searchParam, setSearchParam] = useState("");
  const [tab, setTab] = useState("open");
  const [tabOpen, setTabOpen] = useState("open");
  const [ticketsChannel, setTicketsChannel] = useState(() => {
    try {
      const saved = localStorage.getItem("watoolx.ticketsChannel");
      if (saved === "whatsapp" || saved === "telegram" || saved === "all") return saved;
    } catch (e) {
      /* ignore */
    }
    return "all";
  });
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false); // ✅ AGREGADO: Para confirmación de cerrar tickets
  // ✅ ELIMINADO: duplicateTicketsModalOpen - Ya no se usa

  const searchInputRef = useRef();
  const { user } = useContext(AuthContext);
  const canSeeTeam = canSeeTeamTickets(user);
  const [showAllTickets, setShowAllTickets] = useState(false);

  useEffect(() => {
    if (canSeeTeam) {
      setShowAllTickets(true);
    }
  }, [canSeeTeam]);
  const [openCount, setOpenCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  // ✅ NUEVOS CONTADORES PARA PESTAÑAS MEJORADAS
  const [groupsCount, setGroupsCount] = useState(0);
  const [aiAgentsCount, setAiAgentsCount] = useState(0);
  const [allTicketsCount, setAllTicketsCount] = useState(0); // ✅ AGREGADO: Contador para vista "TODOS"
  const [closedCount, setClosedCount] = useState(0);
  const [unreadOnly, setUnreadOnly] = useState(false);
  const [miosAnchorEl, setMiosAnchorEl] = useState(null);
  const [kebabAnchorEl, setKebabAnchorEl] = useState(null);

  // ✅ Inicializar con array vacío (sin filtro por defecto)
  const [selectedQueueIds, setSelectedQueueIds] = useState([]);

  // ✅ ESTADO PARA EL BUSCADOR Y BOTONES DE ACCESO RÁPIDO
  const [localSearchParam, setLocalSearchParam] = useState("");
  const [searchOnMessages, setSearchOnMessages] = useState(false);
  
  // ✅ ESTADO PARA BÚSQUEDA GLOBAL
  const [globalSearchResults, setGlobalSearchResults] = useState(null);
  const [globalSearchLoading, setGlobalSearchLoading] = useState(false);
  
  // ✅ ESTADO PARA FILTROS
  const [selectedTagIds, setSelectedTagIds] = useState([]);
  const [filterResults, setFilterResults] = useState(null);
  const [filterLoading, setFilterLoading] = useState(false);
  const [tags, setTags] = useState([]);
  const [filterPanelOpen, setFilterPanelOpen] = useState(false);
  const [tagFilterAnchorEl, setTagFilterAnchorEl] = useState(null);
  const [queueFilterAnchorEl, setQueueFilterAnchorEl] = useState(null);
  
  // ✅ ESTADO PARA CONTROLAR QUÉ BOTÓN DE ACCESO RÁPIDO ESTÁ ACTIVO
  const [activeQuickButton, setActiveQuickButton] = useState("open"); // "open", "closed", "all", "new", "resolve", "sort"
  const [closeTicketsOption, setCloseTicketsOption] = useState("open"); // "open", "pending", "both" - Opción seleccionada para cerrar tickets
  const [closeChannel, setCloseChannel] = useState("all"); // "whatsapp", "telegram", "all"
  const [closeCounts, setCloseCounts] = useState(null);

  const tabCountsDebounceRef = useRef(null);
  const fetchTabCountsRef = useRef(async () => {});

  const fetchTabCounts = useCallback(async () => {
    if (!user?.companyId) return;
    try {
      const params = {
        includeAllTab: "true",
        searchParam: globalSearchResults ? "" : searchParam,
        searchOnMessages: searchOnMessages ? "true" : "false",
        sortAscending: "false",
        includeClosed: "true",
        channel: ticketsChannel,
      };
      if (filterResults && selectedQueueIds?.length > 0) {
        params.queueIds = JSON.stringify(selectedQueueIds);
      }
      const { data } = await api.get("/tickets/tab-counts", { params });
      if (typeof data.open === "number") setOpenCount(data.open);
      if (typeof data.pending === "number") setPendingCount(data.pending);
      if (typeof data.ai === "number") setAiAgentsCount(data.ai);
      if (typeof data.groups === "number") setGroupsCount(data.groups);
      if (typeof data.closed === "number") setClosedCount(data.closed);
      if (typeof data.all === "number") {
        setAllTicketsCount(data.all);
      }
    } catch (e) {
      console.error("[TicketsManagerTabs] tab-counts:", e);
    }
  }, [
    user?.companyId,
    showAllTickets,
    globalSearchResults,
    searchParam,
    searchOnMessages,
    filterResults,
    selectedQueueIds,
    ticketsChannel
  ]);

  useEffect(() => {
    fetchTabCountsRef.current = fetchTabCounts;
  }, [fetchTabCounts]);

  useEffect(() => {
    fetchTabCounts();
  }, [fetchTabCounts]);

  // ✅ OBTENER SOCKET MANAGER EN EL NIVEL SUPERIOR
  const socketManager = useContext(SocketContext);

  // ✅ Socket: refresco único de contadores (misma fuente que GET /tickets/tab-counts) — evita drift + listas duplicadas
  useEffect(() => {
    let isMounted = true;

    const companyId = localStorage.getItem("companyId");
    const socket = socketManager.getSocket(companyId);

    const scheduleTabCountsRefresh = () => {
      if (!isMounted) return;
      clearTimeout(tabCountsDebounceRef.current);
      tabCountsDebounceRef.current = setTimeout(() => {
        fetchTabCountsRef.current();
      }, 1200);
    };

    const handleTicketUpdate = () => {
      scheduleTabCountsRefresh();
    };

    if (socket) {
      socket.on(`company-${companyId}-ticket`, handleTicketUpdate);
    }

    return () => {
      isMounted = false;
      clearTimeout(tabCountsDebounceRef.current);
      if (socket) {
        socket.off(`company-${companyId}-ticket`, handleTicketUpdate);
      }
    };
  }, [socketManager]);

  useEffect(() => {
    if (tab === "search") {
      searchInputRef.current.focus();
    }
  }, [tab]);

  // ✅ SINCRONIZAR ESTADO DEL BOTÓN ACTIVO CON LA PESTAÑA PRINCIPAL
  useEffect(() => {
    setActiveQuickButton(tab); // ✅ SINCRONIZAR CON PESTAÑA PRINCIPAL
  }, [tab]);

  // ✅ CARGAR TAGS AL MONTAR
  useEffect(() => {
    const loadTags = async () => {
      const companyId = user?.companyId;
      if (!companyId) return;
      try {
        const { data } = await api.get(`/tags/list`, { params: { companyId } });
        setTags(data || []);
      } catch (err) {
        console.error("Error cargando tags:", err);
      }
    };
    loadTags();
  }, [user?.companyId]); // eslint-disable-line react-hooks/exhaustive-deps

  // ✅ APLICAR FILTROS CUANDO CAMBIAN (con debounce)
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      // Si hay búsqueda global activa, no aplicar filtros (prioridad a búsqueda)
      if (globalSearchResults) {
        setFilterResults(null);
        return;
      }
      
      // ✅ Verificar si hay filtros REALES (no valores por defecto)
      const hasQueueFilter = selectedQueueIds?.length > 0;
      const hasTagFilter = selectedTagIds?.length > 0;
      const hasFilters = hasQueueFilter || hasTagFilter;
      
      if (!hasFilters) {
        setFilterResults(null);
        return;
      }
      
      setFilterLoading(true);
      const params = {};
      if (hasQueueFilter) {
        params.queueIds = JSON.stringify(selectedQueueIds);
      }
      if (hasTagFilter) {
        params.tagIds = JSON.stringify(selectedTagIds);
      }
      
      api.get("/tickets/filter-global", { params })
        .then(({ data }) => {
          setFilterResults(data);
          setFilterLoading(false);
        })
        .catch((error) => {
          console.error("❌ Error en filtrado global:", error);
          console.error("❌ Error response:", error.response?.data);
          setFilterLoading(false);
          setFilterResults(null);
        });
    }, 300); // Debounce de 300ms
    
    return () => clearTimeout(timeoutId);
  }, [selectedQueueIds, selectedTagIds, globalSearchResults]);

  let searchTimeout;


  // ✅ FUNCIONES PARA EL BUSCADOR Y BOTONES DE ACCESO RÁPIDO
  const handleNewSearch = async (e) => {
    const searchedTerm = e.target.value.toLowerCase();
    setLocalSearchParam(searchedTerm);

    clearTimeout(searchTimeout);

    if (searchedTerm === "") {
      setLocalSearchParam("");
      setSearchParam("");
      setGlobalSearchResults(null);
      setGlobalSearchLoading(false);
      // ✅ Si hay filtros activos, volver a aplicarlos
      if ((selectedQueueIds?.length > 0) || (selectedTagIds?.length > 0)) {
        // Se aplicarán automáticamente por el useEffect de filtros
      }
      return;
    }

    searchTimeout = setTimeout(async () => {
      // ✅ LLAMAR A API DE BÚSQUEDA GLOBAL
      setGlobalSearchLoading(true);
      try {
        const { data } = await api.get("/tickets/search-global", {
          params: {
            searchParam: searchedTerm,
            searchOnMessages: searchOnMessages ? "true" : "false"
          }
        });
        
        setGlobalSearchResults(data);
        setGlobalSearchLoading(false);
        // ✅ Limpiar filtros cuando hay búsqueda activa
        setFilterResults(null);
      } catch (error) {
        console.error("❌ Error en búsqueda global:", error);
        setGlobalSearchLoading(false);
        setGlobalSearchResults(null);
        // ✅ FALLBACK: Usar búsqueda normal si falla la global
        setSearchParam(searchedTerm);
      }
    }, 500);
  };

  const handleShowAllTickets = () => {
    setShowAllTickets(!showAllTickets);
    
    if (!showAllTickets) {
      // ✅ ACTIVAR VISTA "TODOS" - Cambiar a pestaña "all"
      setTab("open"); // Mantener en pestaña principal "open"
      setTabOpen("all"); // Cambiar a pestaña interna "all"
      setActiveQuickButton("all");
    } else {
      // ✅ DESACTIVAR VISTA "TODOS" - Volver a vista normal
      setTab("open");
      setTabOpen("open"); // Volver a pestaña "open"
      setActiveQuickButton("open");
    }
  };

  const handleNewTicket = () => {
    setNewTicketModalOpen(true); // ✅ ABRIR MODAL PARA CREAR NUEVO TICKET
  };

  const handleResolveTickets = () => {
    setCloseChannel(ticketsChannel === "whatsapp" || ticketsChannel === "telegram" ? ticketsChannel : "all");
    setCloseCounts(null);
    setConfirmationModalOpen(true);
  };

  useEffect(() => {
    if (!confirmationModalOpen) return undefined;
    let active = true;
    Promise.all(["whatsapp", "telegram"].map((channel) =>
      api.get("/tickets/tab-counts", { params: { channel } }).then(({ data }) => [channel, {
        open: Number(data.open) || 0,
        pending: Number(data.pending) || 0
      }])
    )).then((pairs) => {
      if (!active) return;
      const next = { whatsapp: { open: 0, pending: 0 }, telegram: { open: 0, pending: 0 } };
      pairs.forEach(([channel, counts]) => { next[channel] = counts; });
      setCloseCounts(next);
    }).catch(() => {
      if (active) setCloseCounts({ whatsapp: { open: 0, pending: 0 }, telegram: { open: 0, pending: 0 } });
    });
    return () => { active = false; };
  }, [confirmationModalOpen]);

  const selectedCloseCounts = () => {
    if (!closeCounts) return { open: 0, pending: 0 };
    if (closeChannel === "whatsapp" || closeChannel === "telegram") return closeCounts[closeChannel];
    return {
      open: closeCounts.whatsapp.open + closeCounts.telegram.open,
      pending: closeCounts.whatsapp.pending + closeCounts.telegram.pending
    };
  };

  const channelCloseTotal = (channel) => {
    if (!closeCounts) return 0;
    const counts = closeCounts[channel];
    return (counts?.open || 0) + (counts?.pending || 0);
  };

  // ✅ FUNCIÓN PARA VERIFICAR SI HAY TICKETS PARA CERRAR
  const hasTicketsToClose = () => {
    if (!closeCounts) return false;
    const counts = selectedCloseCounts();
    if (closeTicketsOption === "open") return counts.open > 0;
    if (closeTicketsOption === "pending") return counts.pending > 0;
    if (closeTicketsOption === "both") return (counts.open + counts.pending) > 0;
    return false;
  };

  // ✅ FUNCIÓN PARA CONFIRMAR CERRAR TODOS LOS TICKETS
  const handleConfirmCloseAllTickets = async () => {
    // ✅ VALIDACIÓN DE SEGURIDAD: Verificar que hay tickets para cerrar
    if (!hasTicketsToClose()) {
      console.warn("⚠️ No hay tickets para cerrar según la opción seleccionada");
      return; // ✅ NO HACER NADA SI NO HAY TICKETS
    }

    console.log("🎮 CONFIRMANDO CERRAR TODOS LOS TICKETS - Opción seleccionada:", closeTicketsOption);
    setConfirmationModalOpen(false); // ✅ CERRAR MODAL
    
    try {
      // ✅ DETERMINAR QUÉ STATUS CERRAR SEGÚN LA OPCIÓN SELECCIONADA
      let statusesToClose = [];
      
      if (closeTicketsOption === "open") {
        statusesToClose = ["open"];
      } else if (closeTicketsOption === "pending") {
        statusesToClose = ["pending"];
      } else if (closeTicketsOption === "both") {
        statusesToClose = ["open", "pending"];
      }
      
      // ✅ FILTRAR STATUS QUE REALMENTE TIENEN TICKETS
      const counts = selectedCloseCounts();
      const statusesWithTickets = statusesToClose.filter(status => {
        if (status === "open") return counts.open > 0;
        if (status === "pending") return counts.pending > 0;
        return false;
      });

      // ✅ SI NO HAY TICKETS EN NINGÚN STATUS, NO HACER NADA
      if (statusesWithTickets.length === 0) {
        console.warn("⚠️ No hay tickets para cerrar en ningún status seleccionado");
        return;
      }
      
      console.log("🎮 CERRANDO TICKETS CON STATUS:", statusesWithTickets);
      
      // ✅ CERRAR TICKETS PARA CADA STATUS SELECCIONADO QUE TENGA TICKETS
      const closePromises = statusesWithTickets.map(status =>
        api.post("/tickets/closeAll", { status, channel: closeChannel })
      );
      
      await Promise.all(closePromises);
      
      console.log("✅ TODOS LOS TICKETS CERRADOS EXITOSAMENTE");
      fetchTabCounts();
      
    } catch (error) {
      console.error("❌ ERROR AL CERRAR TICKETS:", error);
      // ✅ AQUÍ PODRÍAS AGREGAR UN TOAST DE ERROR SI LO DESEAS
    }
  };

  const handleOpenTickets = () => {
    setTab("open"); // ✅ CAMBIAR A PESTAÑA PRINCIPAL "ABIERTOS"
    setActiveQuickButton("open"); // ✅ MARCAR BOTÓN COMO ACTIVO
  };

  const handleClosedTickets = () => {
    setTab("closed"); // ✅ CAMBIAR A PESTAÑA PRINCIPAL "RESUELTOS"
    setActiveQuickButton("closed"); // ✅ MARCAR BOTÓN COMO ACTIVO
  };


  const selectChannel = (value) => {
    setTicketsChannel(value);
    try {
      localStorage.setItem("watoolx.ticketsChannel", value);
    } catch (e) {
      /* ignore */
    }
  };

  const handleChangeTabOpen = (e, newValue) => {
    selectStatus(newValue);
  };

  const selectStatus = (value) => {
    setTab("open");
    setTabOpen(value);
    if (value === "all") {
      setShowAllTickets(true);
      setActiveQuickButton("all");
      return;
    }
    if (value === "closed") {
      setActiveQuickButton("closed");
      return;
    }
    setShowAllTickets(false);
    setActiveQuickButton(value === "open" ? "open" : value);
  };

  const statusCountBadge = (count) =>
    count > 0 ? (
      <span className={classes.statusCount}>{count > 99 ? "99+" : count}</span>
    ) : null;


  // ✅ FUNCIÓN PARA NAVEGAR A UN TICKET DESDE FILTROS/BÚSQUEDA
  const handleSelectTicket = (ticket) => {
    if (ticket && ticket.uuid) {
      history.push(`/tickets/${ticket.uuid}`);
    } else if (ticket && ticket.id) {
      history.push(`/tickets/${ticket.id}`);
    }
  };

  // ✅ COMENTADO: handleChangeTab ya no se usa porque las pestañas principales están ocultas
  // const handleChangeTab = (e, newValue) => {
  //   setTab(newValue);
  // };

  const applyPanelStyle = (status) => {
    // ✅ Permitir que siempre mantengan su tamaño natural para el scroll
    // Solo controlar la visibilidad con display en el div padre
    return {
      height: "100%",
      width: "100%"
    };
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      history.push(`/tickets/${ticket.uuid}`);
    }
  };


  const handleCloseTransferModal = () => {
    setTransferTicketModalOpen(false);
  };

  const scopeControl = (
    <>
      <Button
        className={classes.scopeButton}
        startIcon={<ForumIcon fontSize="small" />}
        endIcon={<ExpandMoreIcon fontSize="small" />}
        onClick={(e) => setMiosAnchorEl(e.currentTarget)}
      >
        {showAllTickets ? "Equipo" : "Míos"}
      </Button>
      <Menu
        anchorEl={miosAnchorEl}
        open={Boolean(miosAnchorEl)}
        onClose={() => setMiosAnchorEl(null)}
      >
        <MenuItem
          selected={!showAllTickets}
          onClick={() => {
            if (showAllTickets) handleShowAllTickets();
            setMiosAnchorEl(null);
          }}
        >
          Míos
        </MenuItem>
        <MenuItem
          selected={showAllTickets}
          disabled={!canSeeTeam}
          onClick={() => {
            if (!canSeeTeam) return;
            if (!showAllTickets) handleShowAllTickets();
            setMiosAnchorEl(null);
          }}
        >
          Equipo
        </MenuItem>
      </Menu>
    </>
  );

  const kebabControl = (
    <>
      <IconButton
        size="small"
        style={isMobile ? { marginLeft: 4 } : undefined}
        onClick={(e) => setKebabAnchorEl(e.currentTarget)}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={kebabAnchorEl}
        open={Boolean(kebabAnchorEl)}
        onClose={() => setKebabAnchorEl(null)}
      >
        {isMobile ? (
          [
            <MenuItem
              key="interno"
              onClick={() => {
                setKebabAnchorEl(null);
                history.push("/chats");
              }}
            >
              Interno
            </MenuItem>,
            <MenuItem
              key="unread"
              selected={unreadOnly}
              onClick={() => {
                setUnreadOnly((v) => !v);
                setKebabAnchorEl(null);
              }}
            >
              {unreadOnly ? "Ver todos" : "No leídos"}
            </MenuItem>,
          ]
        ) : null}
        <MenuItem
          onClick={() => {
            setKebabAnchorEl(null);
            handleResolveTickets();
          }}
        >
          {i18n.t("tickets.managerTabs.tooltips.resolveTickets")}
        </MenuItem>
        <MenuItem
          onClick={() => {
            setQueueFilterAnchorEl(kebabAnchorEl);
            setKebabAnchorEl(null);
          }}
        >
          {i18n.t("tickets.managerTabs.tooltips.filterByQueues")}
        </MenuItem>
        <MenuItem
          onClick={() => {
            setTagFilterAnchorEl(kebabAnchorEl);
            setKebabAnchorEl(null);
          }}
        >
          {i18n.t("tickets.managerTabs.tooltips.filterByTags")}
        </MenuItem>
        <MenuItem
          onClick={() => {
            setKebabAnchorEl(null);
            setFilterPanelOpen(!filterPanelOpen);
          }}
        >
          {i18n.t("tickets.managerTabs.tooltips.activeFilters")}
        </MenuItem>
      </Menu>
    </>
  );

  const channelChips = (
    <div className={classes.channelSwitch}>
      <button
        type="button"
        className={`${classes.channelChip}${ticketsChannel === "all" ? ` ${classes.channelChipAllSelected}` : ""}`}
        onClick={() => selectChannel("all")}
      >
        Todos
      </button>
      <button
        type="button"
        className={`${classes.channelChip}${ticketsChannel === "whatsapp" ? ` ${classes.channelChipWhatsappSelected}` : ""}`}
        onClick={() => selectChannel("whatsapp")}
      >
        <span className={classes.channelDot} style={{ backgroundColor: "#25D366" }} />
        WhatsApp
      </button>
      <button
        type="button"
        className={`${classes.channelChip}${ticketsChannel === "telegram" ? ` ${classes.channelChipTelegramSelected}` : ""}`}
        onClick={() => selectChannel("telegram")}
      >
        <span className={classes.channelDot} style={{ backgroundColor: "#229ED9" }} />
        Telegram
      </button>
    </div>
  );

  return (
    <Paper
      elevation={0}
      className={`${classes.ticketsWrapper}${
        ticketsChannel === "whatsapp"
          ? ` ${classes.ticketsWrapperWhatsapp}`
          : ticketsChannel === "telegram"
          ? ` ${classes.ticketsWrapperTelegram}`
          : ""
      }`}
    >
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={(ticket) => {
          
          handleCloseOrOpenTicket(ticket);
        }}
      />
      {/* ✅ PESTAÑAS PRINCIPALES - OCULTADAS PARA USAR BOTONES DE ACCESO RÁPIDO */}
      {/* 
      <Paper elevation={0} square className={classes.tabsHeader}>
        <Tabs
          value={tab}
          onChange={handleChangeTab}
          variant="scrollable" // ✅ NUEVO: Permitir scroll horizontal para pestañas principales
          scrollButtons="auto" // ✅ NUEVO: Mostrar botones de scroll automáticamente cuando sea necesario
          aria-label="scrollable main tabs" // ✅ NUEVO: Accesibilidad
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
          aria-label="icon label tabs example"
        >
          <Tab
            value={"open"}
            icon={<MoveToInboxIcon />}
            label={i18n.t("tickets.tabs.open.title")}
            classes={{ root: classes.tab }}
          />
          <Tab
            value={"closed"}
            icon={<LockIcon />}
            label={i18n.t("tickets.tabs.closed.title")}
            classes={{ root: classes.tab }}
          />
        </Tabs>
      </Paper>
      */}

      {!isMobile && (
      <div className={classes.ticketsTopBar}>
        {scopeControl}
        <Button
          className={classes.ghostButton}
          startIcon={<ForumIcon fontSize="small" />}
          onClick={() => history.push("/chats")}
        >
          Interno
        </Button>
        <Button
          className={unreadOnly ? classes.unreadButton : classes.unreadButtonOff}
          startIcon={<MarkunreadIcon fontSize="small" />}
          onClick={() => setUnreadOnly((v) => !v)}
        >
          No leídos
        </Button>
        {kebabControl}
      </div>
      )}

      {/* ✅ BUSCADOR DE TICKETS Y MENSAJES */}
      <div className={classes.searchInputWrapperNew}>
        <SearchIcon className={classes.searchIconNew} />
        <InputBase
          className={classes.searchInputNew}
          placeholder="Nombre, número o email"
          type="search"
          value={localSearchParam}
          onChange={handleNewSearch}
        />
        <Tooltip placement="top" title={i18n.t("tickets.search.searchMessagesTooltip")}>
          <div>
            <Switch
              size="small"
              className={classes.searchSwitchNew}
              checked={searchOnMessages}
              onChange={(e) => setSearchOnMessages(e.target.checked)}
            />
          </div>
        </Tooltip>
        {isMobile ? (
          <IconButton
            size="small"
            style={{ marginLeft: 2, color: filterPanelOpen ? theme.palette.primary.main : undefined }}
            onClick={() => setFilterPanelOpen(!filterPanelOpen)}
            aria-label={i18n.t("tickets.filterPanel.title")}
          >
            <Badge
              color="primary"
              overlap="circular"
              badgeContent={(selectedQueueIds?.length || 0) + (selectedTagIds?.length || 0) + (ticketsChannel !== "all" ? 1 : 0)}
            >
              <FilterListIcon fontSize="small" />
            </Badge>
          </IconButton>
        ) : null}
        {isMobile ? kebabControl : null}
      </div>

      {/* Filtros de departamentos/etiquetas (menús) */}
      <div className={classes.quickActionsBar} style={{ display: "none" }}>
        <div className={classes.quickActionsLeft} />

        <div className={classes.quickActionsRight}>
          {/* ✅ NUEVO: Botón de filtro de departamentos con icono (similar a otros botones rápidos) */}
          <Tooltip title={i18n.t("tickets.managerTabs.tooltips.filterByQueues")}>
            <IconButton
              onClick={(e) => {
                setQueueFilterAnchorEl(e.currentTarget);
              }}
              className={classes.quickActionIconButton}
              size="small"
              style={{ position: "relative" }}
            >
              <BusinessIcon />
              {selectedQueueIds?.length > 0 && (
                <Chip 
                  label={selectedQueueIds.length} 
                  size="small" 
                  style={{ 
                    position: 'absolute', 
                    top: 4, 
                    right: 4,
                    height: '16px',
                    fontSize: '0.65rem',
                    minWidth: '18px',
                    backgroundColor: selectedQueueIds?.length > 0 ? '#fff' : theme.palette.primary.main,
                    color: selectedQueueIds?.length > 0 ? theme.palette.primary.main : '#fff'
                  }}
                />
              )}
            </IconButton>
          </Tooltip>
          
          {/* ✅ NUEVO: Menú desplegable para seleccionar departamentos */}
          <Menu
            anchorEl={queueFilterAnchorEl}
            open={Boolean(queueFilterAnchorEl)}
            onClose={() => setQueueFilterAnchorEl(null)}
            PaperProps={{
              style: {
                maxHeight: 300,
                width: 250,
                backgroundColor: theme.palette.background.paper,
                border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
              },
            }}
          >
            {user?.queues?.length === 0 && (
              <MenuItem disabled>
                <ListItemText 
                  primary={i18n.t("tickets.managerTabs.emptyQueues")}
                  primaryTypographyProps={{
                    style: { color: theme.palette.text.secondary, fontStyle: 'italic' }
                  }}
                />
              </MenuItem>
            )}
            {user?.queues?.map(queue => (
              <MenuItem
                key={queue.id}
                dense
                onClick={() => {
                  const isSelected = selectedQueueIds.indexOf(queue.id) > -1;
                  if (isSelected) {
                    setSelectedQueueIds(prev => prev.filter(id => id !== queue.id));
                  } else {
                    setSelectedQueueIds(prev => [...prev, queue.id]);
                  }
                }}
              >
                <Checkbox
                  style={{ color: queue.color || theme.palette.primary.main }}
                  size="small"
                  checked={selectedQueueIds.indexOf(queue.id) > -1}
                />
                <ListItemText 
                  primary={queue.name}
                  primaryTypographyProps={{
                    style: { color: theme.palette.text.primary }
                  }}
                />
              </MenuItem>
            ))}
          </Menu>
          
          {/* ✅ NUEVO: Botón de filtro de etiquetas con icono (similar a otros botones rápidos) */}
          <Tooltip title={i18n.t("tickets.managerTabs.tooltips.filterByTags")}>
            <IconButton
              onClick={(e) => {
                setTagFilterAnchorEl(e.currentTarget);
              }}
              className={classes.quickActionIconButton}
              size="small"
              style={{ position: "relative" }}
            >
              <LocalOfferIcon />
              {selectedTagIds?.length > 0 && (
                <Chip 
                  label={selectedTagIds.length} 
                  size="small" 
                  style={{ 
                    position: 'absolute', 
                    top: 4, 
                    right: 4,
                    height: '16px',
                    fontSize: '0.65rem',
                    minWidth: '18px',
                    backgroundColor: selectedTagIds?.length > 0 ? '#fff' : theme.palette.primary.main,
                    color: selectedTagIds?.length > 0 ? theme.palette.primary.main : '#fff'
                  }}
                />
              )}
            </IconButton>
          </Tooltip>
          
          {/* ✅ NUEVO: Menú desplegable para seleccionar etiquetas */}
          <Menu
            anchorEl={tagFilterAnchorEl}
            open={Boolean(tagFilterAnchorEl)}
            onClose={() => setTagFilterAnchorEl(null)}
            PaperProps={{
              style: {
                maxHeight: 300,
                width: 250,
                backgroundColor: theme.palette.background.paper,
                border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
              },
            }}
          >
            {tags.length === 0 && (
              <MenuItem disabled>
                <ListItemText 
                  primary={i18n.t("tickets.managerTabs.emptyTags")}
                  primaryTypographyProps={{
                    style: { color: theme.palette.text.secondary, fontStyle: 'italic' }
                  }}
                />
              </MenuItem>
            )}
            {tags.map(tag => (
              <MenuItem
                key={tag.id}
                dense
                onClick={() => {
                  const isSelected = selectedTagIds.indexOf(tag.id) > -1;
                  if (isSelected) {
                    setSelectedTagIds(prev => prev.filter(id => id !== tag.id));
                  } else {
                    setSelectedTagIds(prev => [...prev, tag.id]);
                  }
                }}
              >
                <Checkbox
                  style={{ color: tag.color || theme.palette.primary.main }}
                  size="small"
                  checked={selectedTagIds.indexOf(tag.id) > -1}
                />
                <ListItemText 
                  primary={tag.name}
                  primaryTypographyProps={{
                    style: { color: theme.palette.text.primary }
                  }}
                />
              </MenuItem>
            ))}
          </Menu>
          
          {/* ✅ NUEVO: Botón para abrir panel de filtros */}
          <Tooltip title={i18n.t("tickets.managerTabs.tooltips.activeFilters")}>
            <IconButton
              size="small"
              onClick={() => setFilterPanelOpen(!filterPanelOpen)}
              className={classes.quickActionIconButton}
              style={{ position: "relative" }}
            >
              <FilterListIcon />
              {((selectedQueueIds?.length > 0) || (selectedTagIds?.length > 0)) && (
                <Chip 
                  label={(selectedQueueIds?.length || 0) + (selectedTagIds?.length || 0)} 
                  size="small" 
                  style={{ 
                    position: 'absolute', 
                    top: 4, 
                    right: 4,
                    height: '16px',
                    fontSize: '0.65rem',
                    minWidth: '18px',
                    backgroundColor: filterPanelOpen ? '#fff' : theme.palette.primary.main,
                    color: filterPanelOpen ? theme.palette.primary.main : '#fff'
                  }}
                />
              )}
            </IconButton>
          </Tooltip>
        </div>
      </div>

      {/* ✅ NUEVO: Panel de filtros */}
      <FilterPanel
        open={filterPanelOpen}
        onToggle={() => setFilterPanelOpen(!filterPanelOpen)}
        selectedQueueIds={selectedQueueIds}
        selectedTagIds={selectedTagIds}
        queues={user?.queues}
        tags={tags}
        onClearFilters={() => {
          setSelectedQueueIds([]);
          setSelectedTagIds([]);
        }}
        onRemoveQueue={(queueId) => {
          setSelectedQueueIds(prev => prev.filter(id => id !== queueId));
        }}
        onRemoveTag={(tagId) => {
          setSelectedTagIds(prev => prev.filter(id => id !== tagId));
        }}
        extraActiveCount={isMobile && ticketsChannel !== "all" ? 1 : 0}
        hideHeader={isMobile}
      >
        {isMobile ? (
          <div className={classes.mobileFilterControls}>
            {scopeControl}
            {channelChips}
          </div>
        ) : null}
      </FilterPanel>

      {!isMobile && channelChips}

      <TabPanel value={tab} name="open" className={classes.ticketsWrapper}>
        <div style={{ display: "flex", alignItems: "center" }}>
        <Tabs
          value={!(user?.allowGroup || user?.allowTelegramGroups) && tabOpen === "groups" ? "open" : tabOpen}
          onChange={handleChangeTabOpen}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons={isMobile ? "off" : "auto"}
          aria-label="scrollable tabs"
          className={`${classes.statusTabs}${
            ticketsChannel === "whatsapp"
              ? ` ${classes.statusTabsWhatsapp}`
              : ticketsChannel === "telegram"
              ? ` ${classes.statusTabsTelegram}`
              : ""
          }`}
        >
          <Tab
            label={
              <span>
                En atención
                {statusCountBadge(openCount)}
              </span>
            }
            value={"open"}
          />
          <Tab
            label={
              <span>
                En espera
                {statusCountBadge(pendingCount)}
              </span>
            }
            value={"pending"}
          />
          {(user?.allowGroup || user?.allowTelegramGroups) && (
            <Tab
              label={
                <span>
                  {i18n.t("tickets.managerTabs.tabs.groups")}
                  {statusCountBadge(groupsCount)}
                </span>
              }
              value={"groups"}
            />
          )}
          <Tab
            label={
              <span>
                {i18n.t("tickets.managerTabs.tabs.aiAgents")}
                {statusCountBadge(aiAgentsCount)}
              </span>
            }
            value={"ai-agents"}
          />
          <Tab
            label={
              <span>
                Resueltos
                {statusCountBadge(closedCount)}
              </span>
            }
            value={"closed"}
          />
          <Tab
            label={
              <span>
                Todos
                {statusCountBadge(allTicketsCount)}
              </span>
            }
            value={"all"}
          />
        </Tabs>
        {!isMobile && (
        <IconButton
          size="small"
          className={classes.quickActionIconButton}
          style={{ marginRight: 8, marginBottom: 8 }}
          onClick={() => setFilterPanelOpen(!filterPanelOpen)}
        >
          <FilterListIcon />
        </IconButton>
        )}
        </div>
        <div className={classes.ticketsContainer}>
          {/* ✅ BÚSQUEDA GLOBAL: Mostrar resultados agrupados si hay búsqueda activa */}
          {globalSearchResults && (
            <div style={{ 
              flex: "none",
              maxHeight: "60%",
              overflowY: "auto",
              marginBottom: 8,
              padding: "0 8px"
            }}>
              <SearchResultsPanel
                results={globalSearchResults}
                searchParam={localSearchParam}
                loading={globalSearchLoading}
                onTicketClick={handleSelectTicket}
              />
            </div>
          )}
          
          {/* ✅ FILTROS: Mostrar resultados filtrados si hay filtros activos (solo si no hay búsqueda) */}
          {!globalSearchResults && filterResults && (
            <div style={{ 
              flex: "none",
              maxHeight: "60%",
              overflowY: "auto",
              marginBottom: 8,
              padding: "0 8px"
            }}>
              <SearchResultsPanel
                results={filterResults}
                searchParam=""
                loading={filterLoading}
                onTicketClick={handleSelectTicket}
                isFilterMode={true}
              />
            </div>
          )}
          
          {/* ✅ Solo montar la lista de la pestaña activa: menos GET /tickets, menos sockets y menos avatares a la vez */}
          {tabOpen === "open" && (
            <div
              style={{
                display: "flex",
                flex: 1,
                height: "100%",
                flexDirection: "column",
                minHeight: 0
              }}
            >
              <TicketsListCustom
                status="open"
                showAll={canSeeTeam && showAllTickets}
                selectedQueueIds={filterResults ? selectedQueueIds : undefined}
                style={applyPanelStyle("open")}
                searchOnMessages={searchOnMessages}
                withUnreadMessages={unreadOnly ? "true" : undefined}
                searchParam={globalSearchResults ? "" : searchParam}
                isActiveTab
                excludeAIAgents={true}
                channel={ticketsChannel}
              />
            </div>
          )}
          {tabOpen === "pending" && (
            <div
              style={{
                display: "flex",
                flex: 1,
                height: "100%",
                flexDirection: "column",
                minHeight: 0
              }}
            >
              <TicketsListCustom
                status="pending"
                selectedQueueIds={filterResults ? selectedQueueIds : undefined}
                style={applyPanelStyle("pending")}
                searchOnMessages={searchOnMessages}
                withUnreadMessages={unreadOnly ? "true" : undefined}
                searchParam={searchParam}
                isActiveTab
                excludeAIAgents={true}
                channel={ticketsChannel}
              />
            </div>
          )}
          {tabOpen === "all" && (
            <div
              style={{
                display: "flex",
                flex: 1,
                height: "100%",
                flexDirection: "column",
                minHeight: 0
              }}
            >
              <TicketsListCustom
                status="all"
                showAll={true}
                selectedQueueIds={filterResults ? selectedQueueIds : undefined}
                style={applyPanelStyle("all")}
                searchOnMessages={searchOnMessages}
                withUnreadMessages={unreadOnly ? "true" : undefined}
                searchParam={searchParam}
                isActiveTab
                channel={ticketsChannel}
              />
            </div>
          )}
          {(user?.allowGroup || user?.allowTelegramGroups) && tabOpen === "groups" && (
            <div
              style={{
                display: "flex",
                flex: 1,
                height: "100%",
                flexDirection: "column",
                minHeight: 0
              }}
            >
              <TicketsListCustom
                status="group"
                selectedQueueIds={filterResults ? selectedQueueIds : undefined}
                style={applyPanelStyle("groups")}
                searchOnMessages={searchOnMessages}
                withUnreadMessages={unreadOnly ? "true" : undefined}
                searchParam={searchParam}
                isActiveTab
                channel={ticketsChannel}
              />
            </div>
          )}
          {tabOpen === "ai-agents" && (
            <div
              style={{
                display: "flex",
                flex: 1,
                height: "100%",
                flexDirection: "column",
                minHeight: 0
              }}
            >
              <TicketsListCustom
                status="ai"
                selectedQueueIds={filterResults ? selectedQueueIds : undefined}
                style={applyPanelStyle("ai-agents")}
                aiAgentFilter={true}
                excludeAIAgents={false}
                searchOnMessages={searchOnMessages}
                withUnreadMessages={unreadOnly ? "true" : undefined}
                searchParam={searchParam}
                isActiveTab
                channel={ticketsChannel}
              />
            </div>
          )}
          {tabOpen === "closed" && (
            <div
              style={{
                display: "flex",
                flex: 1,
                height: "100%",
                flexDirection: "column",
                minHeight: 0
              }}
            >
              <TicketsListCustom
                status="closed"
                showAll={true}
                selectedQueueIds={filterResults ? selectedQueueIds : undefined}
                searchOnMessages={searchOnMessages}
                withUnreadMessages={unreadOnly ? "true" : undefined}
                searchParam={searchParam}
                isActiveTab
                channel={ticketsChannel}
              />
            </div>
          )}
        </div>
      </TabPanel>
      <TabPanel value={tab} name="closed" className={classes.ticketsWrapper}>
        <TicketsListCustom
          status="closed"
          showAll={true}
          selectedQueueIds={filterResults ? selectedQueueIds : undefined} // ✅ Si no hay filtros activos, no pasar queueIds
          searchOnMessages={searchOnMessages}
          searchParam={tab === "closed" ? searchParam : ""}
          isActiveTab={tab === "closed"}
          channel={ticketsChannel}
        />
      </TabPanel>
      <TransferTicketModalCustom
        modalOpen={transferTicketModalOpen}
        onClose={handleCloseTransferModal}
        ticketid={null}
      />
      
      {/* ✅ MODAL DE CONFIRMACIÓN MEJORADO PARA CERRAR TODOS LOS TICKETS */}
      <ConfirmationModal
        title={i18n.t("ticketsManager.confirmation.title")}
        open={confirmationModalOpen}
        onClose={() => {
          setConfirmationModalOpen(false);
          setCloseTicketsOption("open");
          setCloseChannel("all");
          setCloseCounts(null);
        }}
        onConfirm={handleConfirmCloseAllTickets}
        confirmDisabled={!hasTicketsToClose()} // ✅ DESHABILITAR SI NO HAY TICKETS
        maxWidth="sm"
        fullWidth
      >
        <Box display="flex" flexDirection="column" alignItems="center" p={2}>
          {/* ✅ ICONO DE ALERTA GRANDE */}
          <WarningIcon 
            style={{ 
              fontSize: 64, 
              color: '#ff9800', 
              marginBottom: 16 
            }} 
          />
          
          {/* ✅ TÍTULO PRINCIPAL */}
          <Typography 
            variant="h6" 
            component="h2" 
            align="center" 
            gutterBottom
            style={{ 
              fontWeight: 'bold', 
              color: theme.mode === 'dark' ? '#f87171' : '#d32f2f' 
            }}
          >
            {i18n.t("ticketsManager.confirmation.title")}
          </Typography>
          
          {/* ✅ SUBTÍTULO EXPLICATIVO */}
          <Typography 
            variant="body1" 
            align="center" 
            gutterBottom
            style={{ 
              marginBottom: 16, 
              color: theme.palette.text.secondary || theme.palette.text.primary 
            }}
          >
            {i18n.t("ticketsManager.confirmation.subtitle")}
          </Typography>
          
          <Typography
            variant="body1"
            align="center"
            gutterBottom
            style={{
              fontWeight: "bold",
              marginBottom: 12,
              color: theme.palette.text.primary
            }}
          >
            {i18n.t("ticketsManager.confirmation.whichChannelQuestion")}
          </Typography>
          <FormControl component="fieldset" style={{ width: "100%", marginBottom: 16 }}>
            <RadioGroup
              value={closeChannel}
              onChange={(e) => setCloseChannel(e.target.value)}
              style={{ width: "100%" }}
            >
              {[
                ["whatsapp", "ticketsManager.confirmation.channelWhatsapp", "#25D366"],
                ["telegram", "ticketsManager.confirmation.channelTelegram", "#2AABEE"],
                ["all", "ticketsManager.confirmation.channelBoth", theme.palette.text.primary]
              ].map(([value, labelKey, color]) => (
                <Box
                  key={value}
                  onClick={() => setCloseChannel(value)}
                  style={{
                    marginBottom: 8,
                    padding: "8px 12px",
                    border: `1px solid ${closeChannel === value ? color : (theme.mode === "dark" ? "#4B5563" : "#e0e0e0")}`,
                    borderRadius: 8,
                    backgroundColor: closeChannel === value
                      ? (theme.mode === "dark" ? "#374151" : "#f8fafc")
                      : (theme.mode === "dark" ? "#1f2937" : "#fff"),
                    cursor: "pointer"
                  }}
                >
                  <FormControlLabel
                    value={value}
                    control={<Radio style={{ color }} />}
                    label={
                      <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                        <span style={{ color: theme.palette.text.primary }}>{i18n.t(labelKey)}</span>
                        <Badge
                          badgeContent={value === "all"
                            ? channelCloseTotal("whatsapp") + channelCloseTotal("telegram")
                            : channelCloseTotal(value)}
                          color="primary"
                          style={{ marginLeft: 16 }}
                        />
                      </Box>
                    }
                    style={{ margin: 0, width: "100%" }}
                  />
                </Box>
              ))}
            </RadioGroup>
          </FormControl>

          <Typography
            variant="body1"
            align="center"
            gutterBottom
            style={{
              fontWeight: "bold",
              marginBottom: 16,
              color: theme.palette.text.primary
            }}
          >
            {i18n.t("ticketsManager.confirmation.whichTicketsQuestion")}
          </Typography>

          {/* ✅ MENSAJE INFORMATIVO SI NO HAY TICKETS */}
          {!closeCounts && (
            <Box style={{ padding: "12px 16px", marginBottom: 16, textAlign: "center" }}>
              <Typography variant="body2" color="textSecondary">
                {i18n.t("ticketsManager.confirmation.counting")}
              </Typography>
            </Box>
          )}
          {closeCounts && !hasTicketsToClose() && (
            <Box
              style={{
                padding: '12px 16px',
                marginBottom: 16,
                borderRadius: '8px',
                backgroundColor: theme.mode === 'dark' ? '#1e3a8a' : '#e3f2fd',
                border: `1px solid ${theme.mode === 'dark' ? '#3b82f6' : '#90caf9'}`,
                textAlign: 'center'
              }}
            >
              <Typography 
                variant="body2" 
                style={{ 
                  color: theme.mode === 'dark' ? '#93c5fd' : '#1565c0',
                  fontWeight: '500'
                }}
              >
                <span role="img" aria-label={i18n.t("ticketsManager.confirmation.warningEmojiAria")}>⚠️</span>{" "}
                {i18n.t("ticketsManager.confirmation.noTicketsForOption")}
              </Typography>
            </Box>
          )}
          
          {/* ✅ OPCIONES DE SELECCIÓN */}
          <FormControl component="fieldset" style={{ width: '100%', marginBottom: 16 }}>
            <RadioGroup
              value={closeTicketsOption}
              onChange={(e) => setCloseTicketsOption(e.target.value)}
              style={{ width: '100%' }}
            >
              <Box
                onClick={() => setCloseTicketsOption("open")}
                style={{ 
                  marginBottom: 8, 
                  padding: '12px', 
                  border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
                  borderRadius: '8px',
                  backgroundColor: closeTicketsOption === "open" 
                    ? (theme.mode === 'dark' ? '#4B5563' : '#e3f2fd')
                    : (theme.mode === 'dark' ? '#374151' : '#fff'),
                  transition: 'all 0.2s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  if (closeTicketsOption !== "open") {
                    e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#4B5563' : '#f5f5f5';
                  }
                }}
                onMouseLeave={(e) => {
                  if (closeTicketsOption !== "open") {
                    e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#374151' : '#fff';
                  }
                }}
              >
                <FormControlLabel 
                  value="open" 
                  control={<Radio style={{ color: theme.palette.primary.main }} />} 
                  label={
                    <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                      <span style={{ color: theme.palette.text.primary }}>{i18n.t("ticketsManager.confirmation.optionAttendingOpen")}</span>
                      <Badge badgeContent={selectedCloseCounts().open} color="primary" style={{ marginLeft: 16 }} />
                    </Box>
                  }
                  style={{ margin: 0, width: '100%' }}
                />
              </Box>
              <Box
                onClick={() => setCloseTicketsOption("pending")}
                style={{ 
                  marginBottom: 8, 
                  padding: '12px', 
                  border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
                  borderRadius: '8px',
                  backgroundColor: closeTicketsOption === "pending" 
                    ? (theme.mode === 'dark' ? '#4B5563' : '#fce4ec')
                    : (theme.mode === 'dark' ? '#374151' : '#fff'),
                  transition: 'all 0.2s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  if (closeTicketsOption !== "pending") {
                    e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#4B5563' : '#f5f5f5';
                  }
                }}
                onMouseLeave={(e) => {
                  if (closeTicketsOption !== "pending") {
                    e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#374151' : '#fff';
                  }
                }}
              >
                <FormControlLabel 
                  value="pending" 
                  control={<Radio style={{ color: theme.palette.secondary.main }} />} 
                  label={
                    <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                      <span style={{ color: theme.palette.text.primary }}>{i18n.t("ticketsManager.confirmation.optionPending")}</span>
                      <Badge badgeContent={selectedCloseCounts().pending} color="secondary" style={{ marginLeft: 16 }} />
                    </Box>
                  }
                  style={{ margin: 0, width: '100%' }}
                />
              </Box>
              <Box
                onClick={() => setCloseTicketsOption("both")}
                style={{ 
                  marginBottom: 8, 
                  padding: '12px', 
                  border: `1px solid ${closeTicketsOption === "both" 
                    ? (theme.mode === 'dark' ? '#dc2626' : '#ff9800')
                    : (theme.mode === 'dark' ? '#7c2d12' : '#ff9800')}`,
                  borderRadius: '8px',
                  backgroundColor: closeTicketsOption === "both" 
                    ? (theme.mode === 'dark' ? '#991b1b' : '#fff3e0')
                    : (theme.mode === 'dark' ? '#78350f' : '#fff3e0'),
                  transition: 'all 0.2s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  if (closeTicketsOption !== "both") {
                    e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#991b1b' : '#ffe0b2';
                    e.currentTarget.style.borderColor = theme.mode === 'dark' ? '#dc2626' : '#ff9800';
                  }
                }}
                onMouseLeave={(e) => {
                  if (closeTicketsOption !== "both") {
                    e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#78350f' : '#fff3e0';
                    e.currentTarget.style.borderColor = theme.mode === 'dark' ? '#7c2d12' : '#ff9800';
                  }
                }}
              >
                <FormControlLabel 
                  value="both" 
                  control={<Radio style={{ color: theme.palette.error.main }} />} 
                  label={
                    <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                      <span style={{ color: theme.palette.text.primary, fontWeight: 'bold' }}>{i18n.t("ticketsManager.confirmation.optionBoth")}</span>
                      <Badge badgeContent={selectedCloseCounts().open + selectedCloseCounts().pending} color="error" style={{ marginLeft: 16 }} />
                    </Box>
                  }
                  style={{ margin: 0, width: '100%' }}
                />
              </Box>
            </RadioGroup>
          </FormControl>
          
          {/* ✅ ADVERTENCIA FINAL */}
          <Typography 
            variant="body2" 
            align="center"
            style={{ 
              color: theme.mode === 'dark' ? '#f87171' : '#d32f2f', 
              fontWeight: 'bold',
              backgroundColor: theme.mode === 'dark' ? '#4a1f1f' : '#ffebee',
              padding: '8px 16px',
              borderRadius: '4px',
              border: `1px solid ${theme.mode === 'dark' ? '#7f1d1d' : '#ffcdd2'}`
            }}
          >
            {i18n.t("ticketsManager.confirmation.warning")}
          </Typography>
        </Box>
      </ConfirmationModal>

      {/* ✅ ELIMINADO: Modal de corrección de duplicados - Ya no se usa */}
      <Fab
        className={classes.fabNewTicket}
        onClick={handleNewTicket}
        aria-label={i18n.t("tickets.managerTabs.tooltips.newTicket")}
      >
        <AddIcon />
      </Fab>
    </Paper>
  );
};

export default TicketsManagerTabs;
